import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M41.25 40.0009C41.25 37.9306 42.9297 36.2509 45 36.2509H75C77.0703 36.2509 78.75 37.9306 78.75 40.0009C78.75 42.0712 77.0703 43.7509 75 43.7509H45C42.9297 43.7509 41.25 42.0712 41.25 40.0009ZM21.25 60.0009C21.25 62.0712 22.9297 63.7509 25 63.7509H55C57.0703 63.7509 58.75 62.0712 58.75 60.0009C58.75 57.9306 57.0703 56.2509 55 56.2509H25C22.9297 56.2509 21.25 57.9306 21.25 60.0009ZM11.3004 81.662C4.23798 73.0399 0 62.0151 0 50C0 22.3859 22.3859 0 50 0C77.6141 0 100 22.3859 100 50C100 77.6141 77.6141 100 50 100H6.13403C1.82007 100 -0.46907 94.9026 2.39685 91.6779L11.3004 81.662ZM50 92.5C73.472 92.5 92.5 73.472 92.5 50C92.5 26.528 73.472 7.5 50 7.5C26.528 7.5 7.5 26.528 7.5 50C7.5 60.2194 11.0974 69.5785 17.1024 76.9095C19.4385 79.762 19.3555 83.8888 16.9061 86.6449L11.7014 92.5H50Z'

const IconChat: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} viewBox="0 0 100 100" />
)

export default IconChat
